import styled, { keyframes } from 'styled-components';
import { theme } from '../../styles/theme';

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  color?: string;
  text?: string;
}

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

const SpinnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${theme.spacing.md};
`;

const StyledSpinner = styled.div<{ size: 'sm' | 'md' | 'lg'; color: string }>`
  ${({ size }) => {
    switch (size) {
      case 'sm':
        return `
          width: 20px;
          height: 20px;
          border-width: 2px;
        `;
      case 'lg':
        return `
          width: 48px;
          height: 48px;
          border-width: 4px;
        `;
      default:
        return `
          width: 32px;
          height: 32px;
          border-width: 3px;
        `;
    }
  }}
  
  border: solid ${({ color }) => color};
  border-right-color: transparent;
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;

const SpinnerText = styled.p`
  font-size: ${theme.fontSizes.md};
  color: ${theme.colors.text};
  text-align: center;
  margin: 0;
`;

export const Spinner: React.FC<SpinnerProps> = ({ 
  size = 'md', 
  color = theme.colors.primary,
  text 
}) => {
  return (
    <SpinnerWrapper>
      <StyledSpinner size={size} color={color} />
      {text && <SpinnerText>{text}</SpinnerText>}
    </SpinnerWrapper>
  );
};

const FullPageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  width: 100%;
`;

export const FullPageSpinner: React.FC<{ text?: string }> = ({ text = 'טוען...' }) => {
  return (
    <FullPageWrapper>
      <Spinner size="lg" text={text} />
    </FullPageWrapper>
  );
};
